import { render, staticRenderFns } from "./deleteLogDetail.vue?vue&type=template&id=913a93d8&scoped=true&"
import script from "./deleteLogDetail.vue?vue&type=script&lang=js&"
export * from "./deleteLogDetail.vue?vue&type=script&lang=js&"
import style0 from "./deleteLogDetail.vue?vue&type=style&index=0&id=913a93d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913a93d8",
  null
  
)

export default component.exports